'use client';
import React from 'react';
import { withOptionalId } from '@lib/withOptionalId';

type AsideProps = React.HTMLAttributes<HTMLElement> & {
  asideID?: string;
  className?: string;
};

const Aside = ({ asideID, className, children, ...rest }: AsideProps) => {
  return (
    <aside {...withOptionalId(asideID)} className={className} {...rest}>
      {children}
    </aside>
  );
};

export default Aside;
